import {Route, Routes} from 'react-router-dom';
import {AuthProvider} from './components/AuthComponents';
import ApiKey from './routes/ApiKey';
import Collections from './routes/Collections';
import Home from './routes/Home';
import Join from './routes/Join';
import Layout from './layout/Layout';
import Login from './routes/Login';
import Privacy from './routes/Privacy';
import PublicLayout from './layout/PublicLayout';
import Setting from './routes/Setting';
import NotFound from './routes/NotFound';
import Surveilances from './routes/Surveilances';
import DataView from './routes/DataView';
import Logout from './routes/Logout';

import './App.css';
import Preparation from './routes/Preparation';
import RelaseNote from './routes/ReleaseNote';

function App() {
    return (
        <div id='App'>
            <AuthProvider>
                <Routes>
                    <Route element={<Layout />}>
                        <Route path='/' element={<Home></Home>} />
                        <Route path='/setting' element={<Preparation></Preparation>} />
                        <Route path='/apiKey' element={<ApiKey></ApiKey>} />
                        <Route path='/collections' element={<Collections></Collections>} />
                        <Route path='/surveilances' element={<Preparation></Preparation>} />
                        <Route path='/dataView/:id' element={<DataView></DataView>} />
                        <Route path='/logout' element={<Logout></Logout>} />
                    </Route>
                    <Route element={<PublicLayout />}>
                        <Route path='/login' element={<Login></Login>} />
                        <Route path='/join' element={<Join></Join>} />
                        <Route path='/privacy' element={<Privacy></Privacy>} />
                        <Route path='/releaseNote' element={<RelaseNote></RelaseNote>} />
                        <Route path='*' element={<NotFound></NotFound>} />
                    </Route>
                </Routes>
            </AuthProvider>
        </div>
    );
}

export default App;
